<template>
    <div class="popup" id="alarmReservePopup" :class="{ active: popupVisible }">
        <div class="popup__inner type2">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>알림톡 서비스</h2>
                    <button type="button" class="popup__close" @click="hidePopup"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="info">
                        <p class="popup__desc-point">
                            카카오 알림톡 간편 진료예약 전 개인정보 수집·이용에
                            대한 내용을 반드시 확인해주세요.
                        </p>
                    </div>
                    <div class="info">
                        <ul>
                            <li>1. 개인정보 등의 수집·이용 목적: 첫방문 고객 또는 비회원 고객이 빠르게 예약을 진행하기 위한 용도</li>
                            <li>2. 수집하려는 개인정보 항목: (필수) 이름, 휴대폰번호</li>
                            <li class="point-desc font-main">3. 개인정보 등의 보유 및 이용 기간 : 정보 보유하지 않음</li>
                            <li>4. 귀하는 본 개인 정보 수집 · 이용에 대한 동의를 거부할 권리가 있습니다. 동의하지 않을 시에는 간편 진료예약 안내를 카카오 알림톡으로 받으실 수 없습니다.</li>
                            <li>위와 같이 개인 정보를 수집·이용하는데 동의하십니까?</li>
                        </ul>
                    </div>

                    <div class="checkbox-wrap info">
                        <label  >
                            <input type="checkbox" name="test02" id="test02" v-model="agree">
                            <span class="checkbox-btn"></span>
                            <p><span class="c-red">*</span> 동의합니다</p>
                        </label>
                    </div>

                    <div class="botton-wrap type02">
                        <a href="javascript:;" class="sub-button c-main mo-none" @click="hidePopup">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="simpleAction">알림톡으로 진료 예약</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            popupVisible: {
                type: Boolean,
                required: true
            },
            name:'',
            tel: '',
        },
        data() {
            return {
                agree: false,
            }
        },
        methods: {
            simpleAction(){
                if(!this.agree){
                    alert("개인정보 수집 이용에 동의가 필요합니다.")
                    return
                }

                
                this.axios.get(this.api.appointment.simpleReservationTalk, {
                    params: {
                        IN_TEL_NO: this.tel,
                    }
                }).then(response => {
                    alert(response.data.msg)
                    this.hidePopup()
                    if(response.data.success != "Y"){
                        location.reload()
                    }
                }).catch(err => {
                    alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
                    this.hidePopup()
                });
            },
            hidePopup() {
                this.agree = false
                if(!this.popupVisible){
                    document.querySelector('#alarmReservePopup').style.display = 'none'
                }
                this.$emit('hide-popup', 'alarmVisible');
            },
        },
    }
</script>